module.exports = __webpack_public_path__ + "static/media/Brian Peteritas Headshot.ffa0b11c.jpeg";